const footerReducer = (state = {
  copyright: '',
  externals: [
  ],
  social: {
    yt: '',
    vimeo: '',
    fb: '',
    twitter: '',
    instagram: '',
    google: '',
  },
  legals: [],
}, action) => {
  switch (action.type) {
    case 'GET_GLOBALS':
      return {
        ...state,
        ...action.globals.footer,
      };
    default:
      return { ...state };
  }
};

export default footerReducer;



// WEBPACK FOOTER //
// ./frontend/js/Base/Reducers/footerReducer.jsx